export default function Goods(){

    let gsImg = ['goods1.gif', 'goods2.gif', 'goods3.gif','goods4.gif',
    'goods5.gif','goods6.png','goods7.gif','goods8.gif','goods9.gif',
    'goods10.gif','goods11.png','goods12.gif','goods13.gif',
    'goods14.png','goods15.png','goods16.gif','goods17.gif','goods18.gif'].map( (name, k) => {
        return <img key={k} src={require(`../img/${name}`).default} alt=""/>
    } );
    return(
        <>
            <section className="intro">
                <article>
                    <p>칠성사이다 70년의 디자인을 재해석한</p>
                    <h2>칠성사이다 70주년 디자인<br/><b>머천다이징 굿즈</b></h2>
                    <div>각 시대의 디자인 스타일을 정리하고,<br/>70년의 디자인 역사를 재해석&리디자인한<br/>칠성사이다 굿즈를 선보입니다.<br/><br/>
                        70주년을 기념하는 Special Limited Edition!<br/>브랜드 정체성을 기반으로 기능, 소재, 마감까지<br/>최상의 퀄리티를 추구하였습니다.
                    </div>
                </article>
                <figure><img src={ require("../img/goods_page_visual.png").default} alt=""/></figure>
            </section>
            <section className="goods">
                <ul>
                    {
                        gsImg.map((v,k) =>(
                            <li key={k}>
                                {v}
                            </li>
                        ))
                    }
                </ul>
            </section>
        </>
    )
}